exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-not-last[data-v-36d2a03e]{margin-bottom:5px}", ""]);

// exports
